
import SmsSearch from "../../../assets/outline/SmsSearch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SmsSearchIcon({ className, dataTestid = "SmsSearchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SmsSearch data-testid={dataTestid} className={classes} {...rest} />
  );
}
